import React, { useState } from "react";
import { Alert, Box, Button, Card, CardContent, CircularProgress, Typography } from "@mui/material";
import { useBilling } from "../../context/BillingContext";
import { formatCreditCount, formatRupeesFromPaisa, isOwnWallet } from "./billingFormat";
import BuyCreditsDialog from "./BuyCreditsDialog";

const CreditWalletPanel = ({ showBuy = true }) => {
    const { loading, wallet, isCreditBased, canManageBilling, refresh } = useBilling();
    const [buyOpen, setBuyOpen] = useState(false);

    if (loading && !wallet) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                <CircularProgress size={28} />
            </Box>
        );
    }

    if (!isCreditBased || !wallet) {
        return (
            <Alert severity="info">
                This account uses a fixed plan. Credit purchases are not available.
            </Alert>
        );
    }

    const empty = Number(wallet.current_credit) <= 0;
    const shared = !isOwnWallet(wallet);

    return (
        <>
            <Card elevation={0} sx={{ border: "1px solid #e5e7eb", borderRadius: 2 }}>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                    <Typography variant="overline" color="text.secondary">Available balance</Typography>
                    <Typography variant="h3" sx={{ fontWeight: 800, letterSpacing: "-0.03em", color: empty ? "#b91c1c" : "#111827" }}>
                        {formatRupeesFromPaisa(wallet.current_credit)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {formatCreditCount(wallet.current_credit)} · 1 credit = 1 paisa
                    </Typography>
                    {empty && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            The wallet is empty. Sends and AI calls stop until credits are added.
                        </Alert>
                    )}
                    {!empty && (
                        <Alert severity="info" sx={{ mt: 2 }}>
                            A send is refused when the balance is too low, or when a price has not been set for that service.
                        </Alert>
                    )}
                    {shared && (
                        <Alert severity="warning" sx={{ mt: 2 }}>
                            This balance belongs to your account admin. Only they can add credits or view the ledger.
                        </Alert>
                    )}
                    {showBuy && canManageBilling && (
                        <Button variant="contained" sx={{ mt: 2.5 }} onClick={() => setBuyOpen(true)}>
                            Buy credits
                        </Button>
                    )}
                </CardContent>
            </Card>
            <BuyCreditsDialog
                open={buyOpen}
                onClose={() => setBuyOpen(false)}
                onPaid={refresh}
            />
        </>
    );
};

export default CreditWalletPanel;
